import { call, put } from 'redux-saga/effects';
import { IRequestParams, IResponse } from '@dash/apiInstance';
import ApiInstance from 'src/helpers/apiInstance';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notifications from '../notifications/actions';
import { ILoadDataSuccessPayload } from './types';
import actions from './actions';

const api = new ApiInstance('dashboard/metabase');

function* loadMetabaseSettings() {
  try {
    const result: IResponse<ILoadDataSuccessPayload> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      api.get,
      {},
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200 && result?.data) {
      yield put(actions.loadMetabaseSuccess(result.data));
    } else {
      yield put(actions.loadMetabaseError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadMetabaseSettings };
